import React from 'react';
import classNames from 'classnames';

import './StepNavItem.scss';

type StepNavItemProps = {
  isActive: boolean;
  title: string;
  onClick(): void;
};

export const StepNavItem: React.FC<StepNavItemProps> = ({ isActive, title, onClick }) => {
  return (
    <li
      className={classNames({
        'dmx-stepNavItem': true,
        'dmx-stepNavItem-isActive': isActive,
        'dmx-stepNavItem-isNotActive': !isActive,
      })}
      title={title}
      onClick={!isActive ? onClick : undefined}
    >
      <div className='dmx-stepNavItem--inner'>
        {isActive && <span className='sg-u-type-h2'>{title}</span>}
      </div>
    </li>
  );
};
